var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "management" } }, [
    _c(
      "div",
      { staticClass: "position-relative" },
      [
        _c(
          "b-button",
          {
            staticClass: "mb-3",
            attrs: { variant: "primary", size: "sm" },
            on: {
              click: function($event) {
                return _vm.goBack()
              }
            }
          },
          [
            _c("feather-icon", {
              attrs: { width: "16px", height: "16px", icon: "ArrowLeftIcon" }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm.fileOnFlow.detalle.ejecucion
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm.selectedFile
              ? _c(
                  "a",
                  { attrs: { href: _vm.selectedFile.url, target: "_blank" } },
                  [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "text-primary underline d-inline-block mr-2"
                      },
                      [
                        _vm._v(
                          " * Visualizando documento seleccionado " +
                            _vm._s(_vm.selectedFile.nombreCompleto) +
                            " "
                        ),
                        _c("small", [
                          _vm._v("(" + _vm._s(_vm.selectedFile.nombre) + ")")
                        ]),
                        _vm._v(" * ")
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.selectedFile
              ? _c("div", { staticClass: "shadow bg-gray" }, [
                  _vm.fileType === "pdf"
                    ? _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c("PdfViewport", {
                            ref: "pdfViewport",
                            attrs: {
                              "default-page": _vm.currentStepPage,
                              s3url: _vm.selectedFile.url,
                              name: _vm.selectedFile.nombreCompleto,
                              signatures: _vm.signatures,
                              "signature-width": _vm.signatureWidth,
                              "signature-height": _vm.signatureHeight
                            },
                            on: {
                              loaded: _vm.setSign,
                              "signature-drag-end": _vm.onSignatureDragEnd,
                              "signature-delete": _vm.closeSign
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.fileType === "image"
                    ? _c(
                        "div",
                        [
                          _c("b-img", {
                            attrs: {
                              src: _vm.selectedFile.url,
                              fluid: "",
                              alt: _vm.selectedFile.nombreCompleto
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "div",
                { staticClass: "my-3 d-flex justify-content-between" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal",
                          value: "modal-comments",
                          expression: "'modal-comments'"
                        },
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(113, 102, 240, 0.15)",
                          expression: "'rgba(113, 102, 240, 0.15)'",
                          modifiers: { "400": true }
                        }
                      ],
                      staticClass: "btn-icon shadow-lg ",
                      attrs: { id: "toggle-btn", variant: "outline-primary" }
                    },
                    [
                      _vm._v(" comentarios "),
                      _c("feather-icon", {
                        attrs: { icon: "MessageCircleIcon" }
                      })
                    ],
                    1
                  ),
                  _vm.fileOnFlow.detalle && _vm.fileOnFlow.detalle.ejecucion
                    ? _c("Comments", {
                        attrs: {
                          comments: _vm.fileOnFlow.detalle.ejecucion.comentarios
                        }
                      })
                    : _vm._e(),
                  _vm.showSignButton &&
                  _vm.selectedSign.proveedor !== "FirmadorMinisterioEconomia" &&
                    _vm.showSignButton
                    ? _c(
                        "b-button",
                        {
                          ref: "signPosition",
                          staticClass: "btn-icon shadow-lg sign-file",
                          attrs: { variant: "warning" },
                          on: { click: _vm.setSign }
                        },
                        [
                          _vm._v(" estampa "),
                          _c("feather-icon", { attrs: { icon: "FeatherIcon" } })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "b-card",
                { staticClass: "shadow border-0 pt-0" },
                [
                  _c("div", { staticClass: "bg-white pb-2" }, [
                    _vm.fileOnFlow.detalle && _vm.fileOnFlow.detalle.ejecucion
                      ? _c("h5", { staticClass: "card-title mb-0" }, [
                          _vm._v(
                            " Expediente # " +
                              _vm._s(_vm.fileOnFlow.detalle.ejecucion.numero) +
                              " en el " +
                              _vm._s(_vm.fileOnFlow.detalle.ejecucion.nombre) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "text-primary" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.fileOnFlow.detalle.ejecucion.descripcion) +
                          " "
                      )
                    ])
                  ]),
                  _c("b-card-body", { staticClass: "p-0" }, [
                    _c(
                      "div",
                      { staticClass: "mt-2 shadow" },
                      [
                        _vm.fileOnFlow.detalle && _vm.fileOnFlow.detalle.pasos
                          ? _c("Steps", {
                              attrs: {
                                steps: _vm.fileOnFlow.detalle.pasos,
                                ejecucion: _vm.fileOnFlow.detalle.ejecucion
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.fileOnFlow.detalle
                      ? _c(
                          "div",
                          { staticClass: "mt-5 container-actions" },
                          [
                            !_vm.isSigner
                              ? _c("ManageDocument", {
                                  attrs: {
                                    title: _vm.getApprovalRolTitle,
                                    action: "approve",
                                    color: "outline-success",
                                    "step-id": _vm.step
                                  }
                                })
                              : _vm._e(),
                            _vm.fileType === "pdf" &&
                            _vm.showSignButton &&
                            !_vm.toProcessFile &&
                            _vm.canSign
                              ? _c("ManageDocument", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.userSignConfiguration.userSigns
                                          .length,
                                      expression:
                                        "userSignConfiguration.userSigns.length"
                                    }
                                  ],
                                  attrs: {
                                    title: "Firmar Adjunto",
                                    action: "sign-attachment",
                                    color: "outline-success",
                                    "data-cy": "sign",
                                    "step-id": _vm.step,
                                    attachment: _vm.selectedFile,
                                    "get-sign": _vm.getPosition
                                  }
                                })
                              : _vm._e(),
                            _vm.toProcessFile && _vm.isSigner && !_vm.isOffice
                              ? _c("ManageDocument", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.userSignConfiguration.userSigns
                                          .length,
                                      expression:
                                        "userSignConfiguration.userSigns.length"
                                    }
                                  ],
                                  attrs: {
                                    title: "Firmar",
                                    action: "sign",
                                    color: "outline-success",
                                    "step-id": _vm.step,
                                    "get-sign": _vm.getPosition
                                  },
                                  on: {
                                    selectedSign: function($event) {
                                      _vm.selectedSign = $event
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.toProcessFile && _vm.isOffice && !_vm.isFileEDP
                              ? _c("ManageDocument", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.userSignConfiguration.userSigns
                                          .length,
                                      expression:
                                        "userSignConfiguration.userSigns.length"
                                    }
                                  ],
                                  attrs: {
                                    title: _vm.dynamicTitle,
                                    action: "manage",
                                    color: "outline-success",
                                    process: _vm.isOffice,
                                    "step-id": _vm.step,
                                    "get-sign": _vm.getPosition
                                  }
                                })
                              : _vm._e(),
                            _vm.isFileEDP && _vm.toProcessFile && _vm.isOffice
                              ? _c("ManageDocument", {
                                  attrs: {
                                    title: "Entregar fecha",
                                    action: "manage-date",
                                    color: "outline-success",
                                    "step-id": _vm.step,
                                    "get-sign": _vm.getPosition
                                  }
                                })
                              : _vm._e(),
                            _c("ManageDocument", {
                              attrs: {
                                title: "Rechazar",
                                action: "reject",
                                color: "outline-danger",
                                "step-id": _vm.step
                              }
                            }),
                            _c("ManageDocument", {
                              attrs: {
                                title: "Comentar",
                                action: "comment",
                                color: "outline-secondary",
                                "step-id": _vm.step,
                                modal: "comment"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }